const app = (state = {
  lang: 'en',
}, action) => {
  const { type, lang } = action;
  const activeLang = typeof lang !== 'undefined' ? 'ar' : state.lang;
  switch (type) {
    case 'SET_LANGUAGE':
      return { ...state, lang: activeLang };
    default:
      return state;
  }
};

export default app;

/* Selectors: */
export const getLang = state => state.lang;



// WEBPACK FOOTER //
// ./js/reducers/app.js